// Création de l'objet à envoyer au back
const formaterFichierVersoLicenceTir = async (dataForm) => {
    return dataForm.versoLicenceTir ? dataForm.versoLicenceTir[0].getFileToSend() : null;
};

export default formaterFichierVersoLicenceTir;
